const STATUSES = {
    started: 2,
    stopped: 1
}

export default STATUSES